
<template lang="pug">
	a(@click="callService()" v-if="hasOrder" ) {{ orderId }}
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { EventBus } from '@/common/event-bus.js'

export default Vue.extend({
	name: 'ag-grid-view-order',
	data () {
		return {
			isPreview: null,
			popUpPreview: '',
			hasOrder: null,
			order: null,
			items: null,
			card: null,
			contacts: [],
			orderDate: '',
			titleName: null,
			wichParamsIs: null,
			projType: 'orders',
			orderId: ''
		}
	},
	created () {
		this.orderId = (!_.isNil(this.params.data.order)) ? this.params.data.order.orderId : ''
		this.wichParamsIs = this.params.data.projId
		if (this.params.data.isLocked === 1) {
			// console.debug('this Proj has order ', this.wichParamsIs)
			this.hasOrder = true
		} else {
			this.hasOrder = false
		}
	},
	methods: {
		// openPopUp () {
		// },
		callService () {
			this.contacts = []
			Vue.e24.orderService.findOrderByProjId(this.wichParamsIs).then((orderFound) => {
				if (!_.isNil(orderFound)) {
					this.order = orderFound
					this.items = this.params.data.items
					// console.debug('this.items inside btn ', this.items)
					this.orderDate = moment(this.order.dateCreated).format('YYYY-MM-DD HH:MM')

					Vue.e24.contactService.findContactByProjIdAndType(orderFound.projId, 'BO').then((billingContact) => {
						this.contacts.push({title: 'Billing contact', object: billingContact})

						// For display prurpouses only
						this.card = {
							nameOnCard: orderFound.payment.payorName,
							cardNumber: orderFound.payment.number,
							expireMonth: moment(orderFound.payment.expire).format('MM'),
							expireYear: moment(orderFound.payment.expire).format('YY')
						}
						// this.popUpPreview = 'orders'
						EventBus.$emit('orders-pop-up-on', this.order, this.orderDate, this.contacts, this.card)
					})
				} else {
					// Show order not found error
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Order not found',
						text: 'Order not found for project ' + this.projId,
						duration: -1
					})
				}
			})
		}
	}
})
</script>



// WEBPACK FOOTER //
// src/app/project/ag-grid/preview-order-btn.vue